import { render } from "./CreateEventView.vue?vue&type=template&id=152e9c87"
import script from "./CreateEventView.vue?vue&type=script&lang=js"
export * from "./CreateEventView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__